export const videoQuestions = [
  {
    id: "64906f68f61b32bb85167748",
    videoId: "62f215a299fda6c07e15042e",
    question: {
      de: "Was könnte eine mögliche Konsequenz sein, wenn ein Mitarbeiter ständig private Telefonate während der Arbeitszeit führt?",
      tr: "Bir çalışanın mesai saatleri içinde sürekli olarak özel telefon görüşmeleri yapmasının olası sonucu ne olabilir?",
      pl: "Jakie mogą być konsekwencje, jeśli pracownik stale wykonuje prywatne połączenia telefoniczne w godzinach pracy?",
      uk: "Якими можуть бути наслідки, якщо працівник постійно здійснює приватні телефонні дзвінки в робочий час?",
    },
    options: [
      { de: "Beförderung", tr: "Promosyon", pl: "Promocja", uk: "Просування" },
      {
        de: "Entlassung",
        tr: "İşten çıkarılma",
        pl: "Zwolnienie",
        uk: "Звільнення",
      },
      {
        de: "Gehaltserhöhung",
        tr: "Maaş artışı",
        pl: "Wzrost wynagrodzenia",
        uk: "Підвищення заробітної плати",
      },
      {
        de: "Verlängerung der Arbeitszeit",
        tr: "Çalışma süresinin uzatılması",
        pl: "Wydłużenie czasu pracy",
        uk: "Продовження робочого часу",
      },
    ],
    answerIndex: 1,
  },
  {
    id: "64906f68f61b32bb85167749",
    videoId: "63eb7edfafa53ea95bbe8825",
    question: {
      de: "Was sollten Sie als Angestellter tun, wenn Ihr Arbeitgebern*in Sie bittet, eine Aufgabe zu erfüllen, die nicht in Ihrer Stellenbeschreibung steht, wie das Lackieren der Nägel der Arbeitgeberin?",
      tr: "İşvereniniz sizden iş tanımınızda olmayan bir görevi yapmanızı isterse, örneğin işverenin tırnaklarını boyamak gibi, bir çalışan olarak ne yapmalısınız?",
      pl: "Co powinieneś zrobić jako pracownik, jeśli pracodawca poprosi Cię o wykonanie zadania, które nie wchodzi w zakres Twoich obowiązków, np. pomalowanie paznokci pracodawcy?",
      uk: "Що робити працівнику, якщо роботодавець просить вас виконати завдання, яке не входить до ваших посадових обов'язків, наприклад, пофарбувати нігті роботодавцю?",
    },
    options: [
      {
        de: "Sie sollten die Aufgabe ablehnen und sich weigern, weitere Arbeit zu leisten",
        tr: "Görevi reddetmeli ve daha fazla iş yapmayı reddetmelisiniz",
        pl: "Powinieneś odmówić wykonania zadania i odmówić dalszej pracy",
        uk: "Ви повинні відмовитися від завдання і не виконувати будь-яку іншу роботу",
      },
      {
        de: "Sie sollten die Aufgabe ohne Widerspruch erledigen, um Ihren Arbeitsplatz zu sichern",
        tr: "İşinizi güvence altına almak için muhalefet olmadan görevi tamamlamalısınız",
        pl: "Powinieneś wykonać zadanie bez sprzeciwu, aby zapewnić sobie pracę",
        uk: "Ви повинні виконати завдання без опору, щоб зберегти свою роботу",
      },
      {
        de: "Sie sollten die Angelegenheit höflich ansprechen und Ihre Bedenken äußern",
        tr: "Konuyu kibarca gündeme getirmeli ve endişelerinizi ifade etmelisiniz",
        pl: "Powinieneś zgłosić sprawę grzecznie i wyrazić swoje obawy",
        uk: "Ви повинні ввічливо підняти це питання і висловити свої побоювання",
      },
      {
        de: "Sie sollten die Aufgabe erledigen und dann sofort kündigen",
        tr: "İşi yapmalı ve sonra hemen bırakmalısınız",
        pl: "Powinieneś wykonać pracę, a następnie natychmiast zrezygnować",
        uk: "Ви повинні виконати роботу, а потім негайно звільнитися",
      },
    ],
    answerIndex: 2,
  },
  {
    id: "64906f68f61b32bb8516774a",
    videoId: "63eb82e0afa53ea95bbe8826",
    question: {
      de: "Was ist der erste Schritt, den Sie als Arbeitnehmer unternehmen sollten, wenn Ihnen ein privater Gegenstand Ihres Arbeitgebers versehentlich kaputt geht?",
      tr: "İşvereninizin özel eşyalarından birini yanlışlıkla kırmanız durumunda bir çalışan olarak atmanız gereken ilk adım nedir?",
      pl: "Jaki jest pierwszy krok, który powinieneś podjąć jako pracownik, jeśli przypadkowo uszkodzisz jeden z prywatnych przedmiotów swojego pracodawcy?",
      uk: "Які перші кроки ви повинні зробити як працівник, якщо випадково зламали одну з особистих речей вашого роботодавця?",
    },
    options: [
      {
        de: "Ignorieren Sie die Situation und hoffen Sie, dass niemand es bemerkt",
        tr: "Durumu görmezden gelin ve kimsenin fark etmemesini umun",
        pl: "Zignorować sytuację i mieć nadzieję, że nikt tego nie zauważy.",
        uk: "Ігнорувати ситуацію і сподіватися, що її ніхто не помітить",
      },
      {
        de: "Informieren Sie sofort Ihren Arbeitgebern*in und erklären Sie, was passiert ist",
        tr: "İşvereninizi derhal bilgilendirin ve neler olduğunu açıklayın.",
        pl: "Natychmiast poinformuj swojego pracodawcę i wyjaśnij, co się stało.",
        uk: "Негайно повідомте свого роботодавця та поясніть, що сталося.",
      },
      {
        de: "Reparieren Sie den Gegenstand selbst, ohne jemanden zu informieren",
        tr: "Kimseye haber vermeden ürünü kendiniz onarın",
        pl: "Samodzielna naprawa przedmiotu bez informowania kogokolwiek",
        uk: "Відремонтуйте виріб самостійно, нікого не повідомляючи",
      },
      {
        de: "Die Schuld auf jemanden anderes schieben",
        tr: "Suçu başkasının üzerine atmak",
        pl: "Zrzucanie winy na kogoś innego",
        uk: "Перекладання провини на когось іншого",
      },
    ],
    answerIndex: 1,
  },
  {
    id: "64906f68f61b32bb8516774b",
    videoId: "63eb83daafa53ea95bbe8828",
    question: {
      de: "Sie müssen ein Fenster an einer schwer zugänglichen Stelle putzen und es ist nur eine wackelige Leiter vorhanden. Was sollten Sie tun?",
      tr: "Ulaşılması zor bir yerdeki pencereyi temizlemeniz gerekiyor ve sadece sallanan bir merdiven var. Ne yapmalısınız?",
      pl: "Musisz umyć okno w trudno dostępnym miejscu, a do dyspozycji masz tylko chwiejącą się drabinę. Co powinieneś zrobić?",
      uk: "Вам потрібно помити вікно у важкодоступному місці, а там є лише хитка драбина. Що робити?",
    },
    options: [
      {
        de: "Steigen Sie trotzdem auf die Leiter, um die Arbeit zu erledigen",
        tr: "İşi bitirmek için her halükarda merdiveni tırmanın",
        pl: "I tak wspinaj się po drabinie, aby wykonać zadanie",
        uk: "Піднімайтеся по сходах у будь-якому випадку, щоб виконати роботу",
      },
      {
        de: "Stellen Sie einen Stuhl auf den Tisch, um zusätzliche Höhe zu erreichen",
        tr: "Ekstra yükseklik için masanın üzerine bir sandalye yerleştirin",
        pl: "Umieść krzesło na stole, aby uzyskać dodatkową wysokość",
        uk: "Поставте стілець на стіл для додаткової висоти",
      },
      {
        de: "Sprechen Sie das Problem mit Ihrem Arbeitgebern*in an und bitten Sie um eine sicherere Lösung",
        tr: "Sorunu işvereninize iletin ve daha güvenli bir çözüm bulunmasını isteyin",
        pl: "Porusz tę kwestię ze swoim pracodawcą i poproś o bezpieczniejsze rozwiązanie.",
        uk: "Підніміть проблему з роботодавцем і попросіть знайти безпечніше рішення",
      },
      {
        de: "Ignorieren Sie das Fenster und hoffen Sie, dass niemand es bemerkt",
        tr: "Pencereyi görmezden gelin ve kimsenin fark etmemesini umun",
        pl: "Zignoruj okno i miej nadzieję, że nikt go nie zauważy.",
        uk: "Ігнорувати вікно і сподіватися, що його ніхто не помітить",
      },
    ],
    answerIndex: 2,
  },
  {
    id: "64906f68f61b32bb8516774c",
    videoId: "63eb8336afa53ea95bbe8827",
    question: {
      de: "Was könnte ein angemessener Weg sein, um mit einem Arbeitgebern*in umzugehen, der Sie ständig spät am Abend anruft?",
      tr: "Sizi gece geç saatlerde aramaya devam eden bir işverenle başa çıkmanın uygun yolu ne olabilir?",
      pl: "Jaki może być właściwy sposób radzenia sobie z pracodawcą, który dzwoni do ciebie późno w nocy?",
      uk: "Як правильно поводитися з роботодавцем, який продовжує телефонувати до вас пізно вночі?",
    },
    options: [
      {
        de: "Ignorieren Sie die Anrufe vollständig",
        tr: "Çağrıları tamamen görmezden gelin",
        pl: "Całkowite ignorowanie połączeń",
        uk: "Повністю ігнорувати дзвінки",
      },
      {
        de: "Ändern Sie Ihre Telefonnummer ohne den Arbeitgebern*in darüber zu informieren",
        tr: "İşvereninize haber vermeden telefon numaranızı değiştirmek",
        pl: "Zmiana numeru telefonu bez poinformowania pracodawcy",
        uk: "Змінити номер телефону без повідомлення роботодавця",
      },
      {
        de: "Nehmen Sie jeden Anruf entgegen und beantworten Sie alle Fragen sofort",
        tr: "Her çağrıya cevap verin ve tüm soruları anında yanıtlayın",
        pl: "Odbieraj każdy telefon i natychmiast odpowiadaj na wszystkie pytania",
        uk: "Відповідайте на кожен дзвінок і негайно відповідайте на всі запитання",
      },
      {
        de: "Setzen Sie klare Grenzen und kommunizieren Sie diese Ihrem Arbeitgeber, zum Beispiel keine Anrufe nach 18:00 Uhr",
        tr: "Net sınırlar belirleyin ve bunları işvereninize iletin; örneğin, akşam 6'dan sonra arama yapılmaması gibi.",
        pl: "Wyznacz jasne granice i poinformuj o nich pracodawcę, na przykład nie dzwoń po godzinie 18:00 .",
        uk: "Встановіть чіткі межі та повідомте про них роботодавцю, наприклад, жодних дзвінків після 18:00.",
      },
    ],
    answerIndex: 3,
  },
  {
    id: "64906f68f61b32bb8516774d",
    videoId: "62f2151899fda6c07e15042d",
    question: {
      de: "Was ist der erste Schritt, den Sie unternehmen sollten, wenn Sie sich von Ihrem Arbeitgebern*in belästigt fühlen?",
      tr: "İşvereniniz tarafından tacize uğradığınızı hissettiğinizde atmanız gereken ilk adım nedir?",
      pl: "Jaki jest pierwszy krok, który powinieneś podjąć, jeśli czujesz się nękany przez pracodawcę?",
      uk: "Який перший крок ви повинні зробити, якщо відчуваєте утиски з боку роботодавця?",
    },
    options: [
      {
        de: "Ignorieren Sie die Situation und hoffen Sie, dass sie aufhört",
        tr: "Durumu görmezden gelin ve duracağını umun",
        pl: "Ignorowanie sytuacji i liczenie na to, że sama się zatrzyma",
        uk: "Ігнорувати ситуацію і сподіватися, що вона припиниться",
      },
      {
        de: "Konfrontieren Sie den Arbeitgeber*in mit klaren und deutlichen Worten",
        tr: "İşverenle açık ve net sözlerle yüzleşin",
        pl: "Skonfrontuj się z pracodawcą za pomocą jasnych i jednoznacznych słów",
        uk: "Говоріть з роботодавцем чіткими та недвозначними словами",
      },
      {
        de: "Fangen Sie an, sich an Ihrem Arbeitsplatz schlecht zu verhalten, um zurückzuschlagen",
        tr: "Karşı koymak için iş yerinizde kötü davranmaya başlayın",
        pl: "Zacznij źle zachowywać się w miejscu pracy, aby się bronić",
        uk: "Почніть погано поводитися на робочому місці, щоб дати відсіч",
      },
      {
        de: "Kündigen Sie Ihren Job sofort",
        tr: "İşinizi hemen bırakın",
        pl: "Natychmiastowe odejście z pracy",
        uk: "Негайно звільнитися з роботи",
      },
    ],
    answerIndex: 1,
  },
  {
    id: "64906f68f61b32bb8516774e",
    videoId: "62c4381d9d7ed9018ec06f3f",
    question: {
      de: "Was sollten Sie tun, wenn Ihr Arbeitgebern*in Ihnen kein sicheres Reinigungsmittel oder keine Schutzausrüstung zur Verfügung stellt?",
      tr: "İşvereniniz size güvenli bir temizlik ürünü veya koruyucu ekipman sağlamazsa ne yapmalısınız?",
      pl: "Co należy zrobić, jeśli pracodawca nie zapewnia bezpiecznego środka czyszczącego lub sprzętu ochronnego?",
      uk: "Що робити, якщо роботодавець не забезпечує вас безпечним миючим засобом або захисним спорядженням?",
    },
    options: [
      {
        de: "Arbeiten Sie trotzdem, um Ihren Job zu behalten",
        tr: "İşinizi kaybetmemek için yine de çalışın",
        pl: "Pracuj tak czy inaczej, aby utrzymać pracę",
        uk: "Працюйте в будь-якому випадку, щоб зберегти роботу",
      },
      {
        de: "Kaufen Sie Ihre eigene Ausrüstung und Reinigungsmittel und verlangen Sie eine Rückerstattung",
        tr: "Kendi ekipmanınızı ve temizlik malzemelerinizi satın alın ve paranızı geri isteyin",
        pl: "Kup własny sprzęt i środki czyszczące i poproś o zwrot pieniędzy.",
        uk: "Купуйте власне обладнання та засоби для прибирання і вимагайте відшкодування",
      },
      {
        de: "Sprechen Sie das Problem mit Ihrem Arbeitgeber*in an und bestehen Sie auf einer sicheren Arbeitsumgebung",
        tr: "Konuyu işvereninize iletin ve güvenli bir çalışma ortamı için ısrarcı olun.",
        pl: "Porusz tę kwestię ze swoim pracodawcą i nalegaj na zapewnienie bezpiecznego środowiska pracy.",
        uk: "Підніміть це питання перед роботодавцем і наполягайте на створенні безпечних умов праці.",
      },
      {
        de: "Melden Sie Ihren Arbeitgebern*in bei den lokalen Behörden",
        tr: "İşvereninizi yerel makamlara bildirin",
        pl: "Zgłoś swojego pracodawcę władzom lokalnym",
        uk: "Поскаржитися на роботодавця в місцеві органи влади",
      },
    ],
    answerIndex: 2,
  },
  {
    id: "64906f68f61b32bb8516774f",
    videoId: "62c437fc9d7ed9018ec06f3e",
    question: {
      de: "Was ist kein Vorteil einer angemeldeten Tätigkeit in Deutschland?",
      tr: "Almanya'da kayıtlı bir faaliyetin avantajı ne değildir?",
      pl: "Co nie jest zaletą zarejestrowanej działalności w Niemczech?",
      uk: "Що не є перевагою зареєстрованої діяльності в Німеччині?",
    },
    options: [
      {
        de: "Sie sind automatisch gegen Arbeitsunfälle versichert",
        tr: "İş kazalarına karşı otomatik olarak sigortalanırsınız",
        pl: "Jesteś automatycznie ubezpieczony od wypadków przy pracy",
        uk: "Ви автоматично застраховані від нещасних випадків на виробництві",
      },
      {
        de: "Sie erhalten eine Lohnfortzahlung im Krankheitsfall",
        tr: "Hastalık durumunda maaş ödemeleriniz devam eder",
        pl: "Otrzymujesz ciągłość wypłaty wynagrodzenia w przypadku choroby.",
        uk: "Ви отримуєте безперервну виплату заробітної плати у разі хвороби",
      },
      {
        de: "Es besteht die Möglichkeit von bezahltem Urlaub",
        tr: "Ücretli izin imkanı vardır",
        pl: "Istnieje możliwość płatnego urlopu",
        uk: "Існує можливість оплачуваної відпустки",
      },
      {
        de: "Sie können Ihre Arbeitszeiten beliebig wählen",
        tr: "Çalışma saatlerinizi dilediğiniz gibi seçebilirsiniz",
        pl: "Możesz dowolnie wybierać godziny pracy",
        uk: "Ви можете обирати робочий час за власним бажанням",
      },
    ],
    answerIndex: 3,
  },
  {
    id: "64906f68f61b32bb85167750",
    videoId: "62c437789d7ed9018ec06f3d",
    question: {
      de: "Was sollten Sie tun, wenn Sie krank sind und arbeiten müssen?",
      tr: "Hastaysanız ve çalışmak zorundaysanız ne yapmalısınız?",
      pl: "Co zrobić, jeśli jesteś chory i musisz pracować?",
      uk: "Що робити, якщо ви захворіли, але повинні працювати?",
    },
    options: [
      {
        de: "Gehen Sie zur Arbeit, um keine Arbeit zu verpassen",
        tr: "İşi kaçırmamak için işe gidin",
        pl: "Idź do pracy, aby się nie spóźnić",
        uk: "Ходити на роботу, щоб не запізнитися на роботу",
      },
      {
        de: "Bleiben Sie zu Hause und informieren Sie Ihren Arbeitgeber*in über Ihre Krankheit",
        tr: "Evde kalın ve işvereninizi hastalığınız hakkında bilgilendirin.",
        pl: "Zostań w domu i poinformuj pracodawcę o swojej chorobie.",
        uk: "Залишайтеся вдома та повідомте роботодавця про свою хворобу.",
      },
      {
        de: "Gehen Sie zur Arbeit und tragen Sie eine Maske, um andere zu schützen",
        tr: "Başkalarını korumak için işe maske takarak gidin",
        pl: "Chodź do pracy w masce, aby chronić innych",
        uk: "Ходіть на роботу в масці, щоб захистити інших",
      },
      {
        de: "Ignorieren Sie die Symptome und hoffen Sie, dass sie von alleine verschwinden",
        tr: "Semptomları görmezden gelin ve kendiliğinden geçmesini umun",
        pl: "Ignorowanie objawów i liczenie na to, że same ustąpią.",
        uk: "Ігнорувати симптоми і сподіватися, що вони пройдуть самі собою",
      },
    ],
    answerIndex: 1,
  },
];
